import React from 'react';
import List, { defaultFilters } from '../cruds/List';
import { ResendButton, DeleteButton } from '../components/output/CrudButton';
import Table, { Column } from '../components/container/Table';
import OutputValue from '../components/output/OutputValue';
import MainContainer from '../components/MainContainer';
import { Switch, Route } from 'react-router-dom';
import WithRole from '../components/container/WithRole';

const ENTITY_NAME = 'verisksends';
const TITLE = 'verisk.sendtitle';

const CrudList = props => {
  const table = <Table>
                  <Column label="verisk.timestamp" orderingName="TIMESTAMP">
                    <OutputValue name="timestamp" style={{ marginRight: 5 }} />
                  </Column>
                  <Column label="verisk.user" orderingName="USERUUID">
                    <OutputValue name="username" />
                  </Column>
                  <Column label="verisk.product" orderingName="SUBSTANCE">
                    <OutputValue name="substance" />
                  </Column>
                  <Column label="verisk.sdsdocumentname" orderingName="SDSDOCUMENTNAME">
                    <OutputValue name="sdsDocumentName" />
                  </Column>
                  <Column label="verisk.senderror" orderingName="SENDERROR">
                    <OutputValue name="sendError" />
                  </Column>
                  <Column>
                  <WithRole roles={['A', 'B']}>
	                    <ResendButton entityRoute={props.match.url} />
                  </WithRole>
                  <WithRole roles={['A', 'B']}>
                    <DeleteButton />
                  </WithRole>
                  </Column>
                </Table>;

  return <List title={TITLE}
            entityName={ENTITY_NAME}
            entityRoute={ENTITY_NAME}
            component={table}
            defaultOrdering="TIMESTAMP"
            filters={defaultFilters()}
            hideAddButton = {true}
          />;
};

const VeriskSend = props => {
  const basePath = props.match.url;
  return (
    <MainContainer>
      <Switch>
        <Route exact path={basePath} component={CrudList} />
      </Switch>
    </MainContainer>
  );
};

export default VeriskSend;



// WEBPACK FOOTER //
// ./src/main/pages/VeriskSend.js